export const PageLoader = () => (
  <div className="grid min-h-screen place-items-center bg-slate-50">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-line border-t-brand-600" />
  </div>
);
